// extracted by mini-css-extract-plugin
export default {"content":"BlockCard_content__fUJam","list":"BlockCard_list__bY+6W"};